// const meta = {
//   title: "Tabs",
//   type: "rh/components/content/tabs"
// };

// export default meta;

import { TabsV1IsEmptyFn } from "@adobe/aem-core-components-react-spa";

export default {
  title: "Tabs",
  type: "rh/components/content/tabs",
  //   isContainer: true, //not sure here lets try both
  config: {
    emptyLabel: "Tabs",
    isEmpty: TabsV1IsEmptyFn
  }
};
